import {Component, ContentChild} from '@angular/core';
import {AssignmentConfig, MxAssignmentGrid, MxAssignmentGridCustomizerEvent, MxGridCustomizerEvent} from 'mx-core';
import {PrlProductsComponent} from '../prl-products/prl-products.component';

@Component({
    selector: 'prl-product-assignment',
    template: `
        <mx-assignment-grid-dialog (customize)="onCustomize($event)">
            <prl-product (customize)="onCustomizeGrid($event)" #selectionComponent></prl-product>
        </mx-assignment-grid-dialog>
    `,
    standalone: false,
    providers: [{provide: MxAssignmentGrid, useExisting: PrlProductAssignmentComponent}]
})

export class PrlProductAssignmentComponent extends MxAssignmentGrid {
    @ContentChild('selectionComponent') selectionComponent: PrlProductsComponent;

    assignmentConfig: AssignmentConfig = {
        title: 'Products',
        keyField: 'id',
        displayField: 'name'
    };

    onCustomize(event: MxAssignmentGridCustomizerEvent): void {
        event.customizeAssignmentDialog(this.assignmentConfig);
    }

    onCustomizeGrid(event: MxGridCustomizerEvent): void {
        event.customizeRestUrl('/product/normal');
    }
}
